import styled from 'styled-components';

import { OnboardingPage } from '@/pages/Onboarding/components/Page';

export const PageStyles = styled(OnboardingPage)``;

export const OptionCardListStyles = styled.div`
  position: fixed;
  bottom: 24px;
  left: 50%;
  transform: translateX(-50%);
  display: flex;
  gap: 12px;
  z-index: 2;
  width: 100%;
  max-width: 500px;
  padding: 0 16px;
  justify-content: center;
`;

export const OptionCardStyles = styled.div<{ isSelected: boolean }>`
  width: 164px;
  height: 164px;
  border-radius: 12px;
  position: relative;
  cursor: pointer;
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;
  background: ${({ isSelected }) =>
    isSelected ? 'rgba(128, 62, 255, 1)' : 'rgba(255, 255, 255, 0.1)'};
  border: ${({ isSelected }) =>
    isSelected ? '4px solid #803eff' : '4px solid transparent'};
  transition: all 0.2s ease;
`;

export const OptionCardImageStyles = styled.img`
  max-width: 122px;
  max-height: 182px;
  width: auto;
  height: auto;
  object-fit: contain;
  object-position: center;
  z-index: 1;
`;

export const TextStyles = styled.h2`
  font-family: 'Poppins', sans-serif;
  font-weight: 600;
  font-size: 20px;
  line-height: 28px;
  letter-spacing: 0%;
  text-align: center;
  color: #ffffff;
  margin: 0;
  position: fixed;
  bottom: calc(24px + 164px + 24px);
  left: 50%;
  transform: translateX(-50%);
  width: 100%;
  max-width: 500px;
  padding: 0 16px;
  z-index: 2;
`;
